import { Ability } from "@casl/ability";
import { initialAbility } from "./config";

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this


// const userData = JSON.parse(localStorage.getItem('userData'))
// const existingAbility = userData ? userData.ability : null
const existingAbility = JSON.parse(localStorage.getItem(window.brandLocalStorage))?.filter(o => {
  return o.brandRef == new URLSearchParams(window.location.search).get("brandRef") || o.brandRef == sessionStorage.getItem(window.brandSessionStorage)
})?.length > 0
  ? [{ action: "manage", subject: "all" }]
  : null;

export default new Ability(existingAbility || initialAbility);
